import styled from "styled-components";

import { useIsPhoneLayout } from "@pages/AdminDashboard/theme/AdminLayout";
import { adminTokens } from "@pages/AdminDashboard/theme/adminTokens";

import { BannerSection } from "./BannerSection";
import { ButtonSection } from "./ButtonSection";
import { ConfirmDialogSection } from "./ConfirmDialogSection";
import { DataTableSection } from "./DataTableSection";
import {
  CheckboxCardSection,
  DateRangeSection,
  RadioCardGroupSection,
  SearchInputSection,
  SelectSection,
  TextFieldSection,
} from "./FormControlSections";
import {
  CardSection,
  ContextStripSection,
  FieldListSection,
  PageHeaderSection,
} from "./LayoutSections";
import { NoteSection } from "./NoteSection";
import { SegmentedControlSection } from "./SegmentedControlSection";
import { StatusBadgeSection } from "./StatusBadgeSection";
import { ThemeSection } from "./ThemeSection";

const [, , , spaceLg, , spaceXxl] = adminTokens.spacing;

// On a phone the page pads 16px, as the design pads a phone screen.
const Page = styled.div<{ $isPhone: boolean }>`
  min-height: 100%;
  background-color: ${adminTokens.color.canvas};
  padding: ${({ $isPhone }) => ($isPhone ? spaceLg : spaceXxl)}px;
`;

const Title = styled.h1`
  color: ${adminTokens.color.navy};
  font-family: ${adminTokens.typeScale.pageTitle.fontFamily};
  font-size: ${adminTokens.typeScale.pageTitle.fontSize};
  line-height: ${adminTokens.typeScale.pageTitle.lineHeight};
  font-weight: normal;
  margin: 0 0 ${spaceLg}px;
`;

// Reached only through the rebuilt admin's router, so the admin is already
// confirmed by the entry gate (UIKIT-R1, UIKIT-R2).
const UiKitGallery = () => {
  const isPhone = useIsPhoneLayout();

  return (
    <Page data-testid="admin-ui-kit-gallery" $isPhone={isPhone}>
      <Title>UI kit</Title>
      <ThemeSection />
      <ButtonSection />
      <SegmentedControlSection />
      <StatusBadgeSection />
      <BannerSection />
      <NoteSection />
      <CardSection />
      <PageHeaderSection />
      <FieldListSection />
      <ContextStripSection />
      <ConfirmDialogSection />
      <DataTableSection />
      <TextFieldSection />
      <SearchInputSection />
      <SelectSection />
      <DateRangeSection />
      <CheckboxCardSection />
      <RadioCardGroupSection />
    </Page>
  );
};

export default UiKitGallery;
